/*
  Add Custom JS to be layered on top of ciritical theme js
  Events
  
  product:init
  product:variantSelected

  cart:itemAdding
  cart:itemAdded
  cart:updated
  cart:error

  cart:cartOfferComplete

  modal:show
  modal:hide

*/

(function () {
  var urlVariantApplied = false;

  function getUrlVariantId() {
    try {
      return new URLSearchParams(window.location.search).get("variant");
    } catch (e) {
      return null;
    }
  }

  function isHistoryStateEnabled(np) {
    if (!np) return false;
    if (np.getAttribute("data-enable-history-state")) return true;
    var nested = np.querySelector("[data-enable-history-state]");
    return !!(nested && nested.getAttribute("data-enable-history-state"));
  }

  function findVariantById(product, variantId) {
    if (!product || !product.variants || variantId == null) return null;
    variantId = String(variantId);
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === variantId) {
        return product.variants[i];
      }
    }
    return null;
  }

  function syncOptionSelections(np, variant) {
    if (!np || !variant || !np.product || !np.product.options_with_values) return;

    np.product.options_with_values.forEach(function (opt, index) {
      if (variant.options && variant.options[index] != null) {
        opt.selected = variant.options[index];
      }
    });

    np.querySelectorAll("input[neptune-option]").forEach(function (input) {
      var optionName = input.getAttribute("neptune-option");
      if (!optionName) return;

      var optionIndex = -1;
      for (var i = 0; i < np.product.options_with_values.length; i++) {
        if (np.product.options_with_values[i].name === optionName) {
          optionIndex = i;
          break;
        }
      }
      if (optionIndex < 0 || !variant.options) return;
      input.checked = input.value === variant.options[optionIndex];
    });
  }

  function applyUrlVariantFromQuery() {
    if (urlVariantApplied) return false;

    var variantId = getUrlVariantId();
    if (!variantId) return false;

    var np = document.querySelector("[neptune-product]");
    if (!np || !np.product || !isHistoryStateEnabled(np)) return false;

    var variant = findVariantById(np.product, variantId);
    if (!variant) return false;

    np.variant = variant;
    np.variant.quantity = 1;
    syncOptionSelections(np, variant);

    if (window.Neptune && Neptune.product && Neptune.product.variant_in_cart) {
      Neptune.product.variant_in_cart(np);
    }

    var idEl = document.getElementById("sy-product-variant-id");
    if (idEl) idEl.value = String(variant.id);

    if (window._n && window._n.trigger) {
      _n.trigger(np, "product:variantSelected", false, true, variant);
      _n.trigger(document, "product:variantSelected", false, true, {
        el: np,
        variant: variant,
      });
    }

    urlVariantApplied = true;
    return true;
  }

  window.syApplyUrlVariantFromQuery = applyUrlVariantFromQuery;

  document.addEventListener("template:rendered", function (event) {
    var detail = event.detail || {};
    if (detail.topic !== "ProductOptions") return;
    setTimeout(applyUrlVariantFromQuery, 0);
  });

  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(applyUrlVariantFromQuery, 250);
  });
})();

document.addEventListener("product:init", () => {
  setTimeout(() => {
    window.dispatchEvent(new Event("variantExtendLoaded", { detail: { variant: Neptune.products[0].variant.id } }));
  }, 50);
});


document.addEventListener("product:variantSelected", () => {
  window.dispatchEvent(new Event("variantExtendChange", { detail: { variant:_n.qs("[neptune-product]").variant } }))
})


/*
  Do NOT initCart on every cart:updated — that + Extend normalize/refreshCart
  caused 10–15× /cart.js on PDP load (429 / ATC fail).
  Only re-sync Extend after real add / offer / drawer open.
*/
function syDispatchInitCart() {
  if (window.__extendSuppressInitCart) return;
  clearTimeout(window.__syInitCartTimer);
  window.__syInitCartTimer = setTimeout(function () {
    if (window.__extendSuppressInitCart) return;
    window.dispatchEvent(new Event('initCart'));
  }, 400);
}

document.addEventListener("cart:itemAdded", function () {
  syDispatchInitCart();
});

document.addEventListener("cart:cartOfferComplete", function () {
  syDispatchInitCart();
});

document.addEventListener("modal:show", function (event) {
  if(event.detail.info=='cart'){
    window.dispatchEvent(new Event('sideCartOpen'))
  }
})
